// /.auth/me fetcher.
//
// Azure Static Web Apps exposes the signed-in user's identity at
// /.auth/me. Shape:
//   { clientPrincipal: {
//       userId, userDetails, identityProvider, userRoles: [...],
//       claims: [{ typ, val }, ...]
//   } }
//
// When unauthenticated, clientPrincipal is null. Errors propagate so
// AuthProvider can distinguish "logged out" from "fetch failed".

export async function fetchClientPrincipal() {
  const res = await fetch('/.auth/me', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    const err = new Error(`/.auth/me returned ${res.status}: ${body}`);
    err.status = res.status;
    throw err;
  }
  const data = await res.json();
  return data.clientPrincipal || null;
}
